// extracted by mini-css-extract-plugin
export default {"roundButton":"styles_roundButton__Xe8K4","fixed":"styles_fixed__AD8p0","disabled":"styles_disabled__lCHyL","spinner":"styles_spinner__975c-","spin":"styles_spin__BefDD"};